/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Orgs_SubtitleInputs */



/**
* | output |
* | --- |
* | "Every organization across the platform — cloud and partner-managed." |
*
* @param {Partner_Orgs_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_orgs_subtitle = /** @type {((inputs?: Partner_Orgs_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Orgs_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Organisationen der Plattform — Cloud und partnerverwaltet.")
	return /** @type {LocalizedString} */ ("Every organization across the platform — cloud and partner-managed.")
});